import React, { useEffect, useState } from 'react'

interface ReactToastifyProps {
    render: (Toastify: any) => React.ReactNode
}

const ReactToastify = (props: ReactToastifyProps) => {
    const [lib, setLib] = useState<any>(null)

    useEffect(() => {
        import('react-toastify').then((mod) => setLib(mod))
    }, [])

    if (!lib) return null
    return <>{ props.render(lib) }</>
}

export default ReactToastify
